import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Formik } from 'formik';
import Typography from '@material-ui/core/Typography';

import objectsClient from '../../../../clients/objects';

import { fromForm, toForm } from '../../utils/formData';
import validationSchema from '../../utils/validationSchema';
import prepareFiles from '../../utils/prepareFiles';

import Form from '../../components/Form';

const NewObject = () => {
  const history = useHistory();
  const { path } = useRouteMatch();

  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (values) => {
    try {
      const Pictures = await prepareFiles(values.Pictures);
      const AudioRecordings = await prepareFiles(values.AudioRecordings);
      const formData = fromForm({ ...values, Pictures, AudioRecordings });
      
      const { locale, ...objectData } = formData;
      
      // Always create default locale (LT) entry first
      const ltData = locale === 'lt-LT' ? objectData : {
        ...objectData,
        Title: '',
        Description: '',
      };
      
      const { data: { documentId: id } } = await objectsClient.create(ltData, 'lt-LT');

      // If current locale is EN-EU and has data, create EN-EU localization
      if (locale === 'en-EU' && (objectData.Title || objectData.Description)) {
        try {
          await objectsClient.createLocalization(id, objectData, 'en-EU');
        } catch (error) {
          console.error('Failed to create English localization:', error);
          // Show user-friendly error message
          enqueueSnackbar(
            'Objektas sukurtas, bet nepavyko sukurti angliško vertimo. Galite pridėti jį vėliau redaguojant objektą.',
            { variant: 'warning' }
          );
        }
      }

      enqueueSnackbar('Objektas sukurtas', { variant: 'success' });

      history.push(path.replace('/new', `/${id}`));
    } catch (error) {
      console.error('Error creating object:', error);
      enqueueSnackbar('Nepavyko sukurti objekto. Bandykite dar kartą.', {
        variant: 'error',
      });
    }
  };

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Naujas objektas
      </Typography>
      <Formik
        initialValues={{
          locale: 'lt-LT',
          Title: '',
          Description: '',
          Coordinates: null,
          categories: null,
          subcategories: [],
          Region: null,
          District: null,
          GoldCoinAmount: null,
          VideoURL: '',
          WebsiteURL: '',
          BookingURL: '',
          PhoneNumber_1: '',
          PhoneNumber_2: '',
          Pictures: [],
          AudioRecordings: [],
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => <Form {...props} />}
      </Formik>
    </div>
  );
};

export default NewObject;
